<template>
    <div>
        <b-button
            variant="warning"
            @click.stop="obterDotacoesContrato()"
            :disabled="valorDisponivel == 0"
        >
            <span>
                <i class="fa fa-plus mr-2"></i> Obter Dotações do Contrato
            </span>
        </b-button>
        <b-modal 
            v-model="mostrarModal"
        >
            <b-col sm="12" md="12">
                <b-form-group>
                    <label>Dotações orcamentarias</label>
                    <b-form-select
                        :options="dotacoes"
                        v-model="codCCusto"
                        text-field="nomeCCusto"
                        value-field="codCCusto"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <div slot="modal-footer">
            <b-button
                variant="secondary"
                @click.stop="fecharModal()"
                class="mr-2"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                >Salvar</b-button
            >
            </div>
        </b-modal>
    </div>
</template>

<script>
import RequisicoesServicos from '../RequisicoesServicos'

export default {
    props: {
        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        requisicao: {
            type: Object
        }
    },

    data() {
        return {
            dotacoes: [],
            mostrarModal: false,
            codCCusto: '',
            dotacao: {}
        }
    },

    methods: {
        obterDotacoesContrato() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterDotacoesContrato(
                this.requisicao.idRequisicao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.dotacoes = [...response.data]
                        this.inserirDotacoes()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Dotação orçamentaria',
                html: `Confirma a inserção da dotação orçamentaria\n<b>${this.dotacao.nomeCCusto}</b>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar(){
            let novoRateio = {
                codCCusto: this.dotacao.codCCusto,
                nomeCCusto: this.dotacao.nomeCCusto,
                nuValorRateio: this.valorDisponivel
            }
            this.$emit('inserirRateio', novoRateio)
        },

        inserirDotacoes() {
            if (this.dotacoes.length == 1){
                const dotacao = this.dotacoes[0]
                let novoRateio = {
                    codCCusto: dotacao.codCCusto,
                    nomeCCusto: dotacao.nomeCCusto,
                    nuValorRateio: this.valorDisponivel
                }
                this.$emit('inserirRateio', novoRateio)
            }else{
                this.mostrarModal = true
            }
            // for (let index = 0; index < this.dotacoes.length; index++) {
            //     const dotacao = this.dotacoes[index]
            //     let novoRateio = {
            //         codCCusto: dotacao.codCCusto,
            //         nomeCCusto: dotacao.nomeCCusto,
            //         nuValorRateio: this.valorDisponivel / this.dotacoes.length
            //     }
            //     this.$emit('inserirRateio', novoRateio)
            // }
        },

        fecharModal(){
            this.mostrarModal = false
            this.codCCusto =  ''
            this.dotacao = {}
        }
    },

    created() {},

    computed: {},

    watch: {
        codCCusto(){
            this.dotacao = this.dotacoes.find(p => p.codCCusto == this.codCCusto)
        }
    },

    validations: {}
}
</script>
